import { useMemo } from "react"
import { Link } from "@tanstack/react-router"

import type { ProjectStatusTypes } from "@productlane/ui"
import type { Project } from "@productlane/zero"
import { cn } from "@productlane/lib/src/cn"
import { formatRelativeTime } from "@productlane/lib/src/date"
import { ProjectStatusIcon } from "@productlane/ui"

import { useDetailLinkProps } from "@/lib/detail-drawer"
import { getProjectIcon } from "@/lib/projects"

interface Props {
	className?: string
	project: Project
}

export const ProjectTableItem = ({ project, className }: Props) => {
	const Icon = useMemo(() => getProjectIcon(project.icon), [project.icon])
	const projectState = (project.state ?? "backlog") as ProjectStatusTypes
	const linkProps = useDetailLinkProps("project", project.id)
	return (
		<Link {...linkProps}>
			<div
				className={cn(
					"flex w-full flex-row items-center gap-3 px-6 py-3 hover:bg-gray-50 dark:hover:bg-gray-850/50",
					className,
				)}
			>
				<ProjectStatusIcon
					status={projectState}
					className="h-3.5 w-3.5 flex-none"
					colored
				/>
				<Icon
					className="h-4 w-4 flex-none"
					style={{ color: project.color ?? "" }}
				/>
				<div className="flex-1 truncate text-sm font-medium">
					{project.name}
				</div>
				<div className="ml-auto text-xs font-normal text-gray-500">
					{formatRelativeTime(
						new Date(project?.updatedAt ?? project.createdAt),
					)}
				</div>
			</div>
		</Link>
	)
}
